export class EjecutivoBanco {
    constructor(Ejecutivo, Bancolombia, BBVA, Davivienda, Otros, Total) {
        this.Ejecutivo = Ejecutivo;
        this.Bancolombia = Bancolombia;
        this.BBVA = BBVA;
        this.Davivienda = Davivienda;
        this.Otros = Otros;
        this.Total = Total;
    }
}